import { Box, Button, Link } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MarketProLogo from '../../javascript/images/MarketProLogo.png'
import "../../stylesheets/chat_page.css"
import { useState, useEffect } from 'react';
import feedbackIncite from '../api/feedback'
import addSubscriptionCoupon from '../api/subscription'
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';

const SubscriptionCancellationModal = ({ setShowSubCancelModal, getStripeSubscription, isTrialing = false, planLabel = 'Incite Pro' }) => {

  const [opacity, setOpacity] = useState(0)
  const [feedback, setFeedback] = useState('')
  const [canceling, setCanceling] = useState(false)

  useEffect(() => {
    setOpacity(1.0)
  }, [])

  const handleCancel = async () => {
    try {
      const response = await fetch(`/stripe_cancel`);
      const data = await response.json();
      if (!response.ok) {
        return { error: data?.error || "Sesion Error" };
      }
      return data
    } catch (error) {
      console.log('session api errors:', error);
      return { error: "Sesion Error" };
    }
  }

  let classPlaceholderInput = 'feedback-input'

  return (
    <div className="modal modal-paywall" style={{
      opacity: opacity,
      transition: 'opacity 0.25s ease',
      }}>
      <div
        className="paywall-modal-content"
        style={{
          width: '430px',
          maxWidth: 'calc(100% - 32px)',
          maxHeight: 'calc(100vh - 32px)',
          overflowY: 'auto',
          boxSizing: 'border-box',
          padding: '22px 0 26px 0',
          borderRadius: '24px',
          backgroundColor: '#F2F3F5',
          boxShadow: '0 26px 80px rgba(0, 0, 0, 0.28)',
        }}
      >

        <Box
          sx={{
            position: 'absolute',
            top: '18px',
            left: '18px',
            width: '34px',
            height: '34px',
            borderRadius: '17px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#44484F',
            '&:hover': {
              cursor: 'pointer',
              backgroundColor: 'rgba(0, 0, 0, 0.06)',
            }
          }}
          onClick={() => setShowSubCancelModal(false)}
        >
          <CloseIcon sx={{ fontSize: '24px' }} />
        </Box>

        <Box
          className="base-text"
          sx={{
            width: '84%',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <img
            src={MarketProLogo}
            style={{ width: '30px', height: '30px', objectFit: 'contain', opacity: 0.72 }}
            alt="IncitePlus Logo"
          />
          <Box
            sx={{
              mt: '2px',
              mb: '16px',
              fontWeight: 700,
              color: '#1D1D1F',
              fontSize: { xs: '34px', sm: '38px' },
              lineHeight: 1.02,
              letterSpacing: '-0.01em',
            }}
          >
            {planLabel}
          </Box>
        </Box>

        <Box
          className="base-text"
          sx={{
            margin: '0 auto',
            width: '84%',
            textAlign: 'left',
            color: '#111318',
          }}
        >
          {isTrialing ? (
            <>
              <Box sx={{ fontWeight: 700, fontSize: '15px', lineHeight: 1.35, mb: '12px' }}>
                Before you cancel your trial...
              </Box>
              <Box sx={{ fontWeight: 500, fontSize: '14px', lineHeight: 1.45 }}>
                Canceling your trial removes {planLabel} access immediately. If you have feedback,
                please let us know below.
              </Box>
            </>
          ) : (
            <>
              <Box sx={{ fontWeight: 700, fontSize: '15px', lineHeight: 1.35, mb: '12px' }}>
                Before you go...
              </Box>
              <Box sx={{ fontWeight: 500, fontSize: '14px', lineHeight: 1.45 }}>
                We are working on constantly improving Incite. If you have any feedback, please let us know below.
              </Box>
            </>
          )}
        </Box>


          <Box sx={{margin: '22px auto 0 auto', width: '84%',
            }}>
            <textarea
              style={{
                width: '100%',
                height: '134px',
                boxSizing: 'border-box',
                fontSize: '14px',
                lineHeight: '19px',
                position: 'static',
                backgroundColor: '#FFFFFF',
                border: '1px solid #D8DDE5',
                borderRadius: '14px',
                padding: '14px 16px',
                color: '#111318',
                outline: 'none',
              }}
              className={classPlaceholderInput}
              value={feedback}
              onChange={e => {
                setFeedback(e.target.value)
              }}
              placeholder={'Your thoughts..'}
            />
          </Box>

        <Box
          className="base-text"
          sx={{
            width: '84%',
            boxSizing: 'border-box',
            color: '#C92A2A',
            backgroundColor: '#FFF1F1',
            border: '1px solid rgba(201, 42, 42, 0.18)',
            borderRadius: '12px',
            margin: '20px auto 18px auto',
            px: '14px',
            py: '10px',
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: 1.35,
            textAlign: 'center',
          }}
        >
          {isTrialing ? `Are you sure you want to cancel your ${planLabel} trial?` : 'Are you sure you want to cancel?'}
        </Box>
        
        <Box sx={{width: '260px', margin: '0px auto', maxWidth: '84%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <Button variant="contained" className="i_understand_button" sx={{
            textTransform: 'none',
            borderRadius: '999px',
            boxShadow: '0 10px 24px rgba(41, 113, 215, 0.22)',
            width: '100%',
            maxWidth: '100%',
            height: '50px',
            textAlign: 'center',
            backgroundColor: '#2971D7',
            '&:hover': {
              backgroundColor: '#2365C2',
              boxShadow: '0 10px 24px rgba(41, 113, 215, 0.26)',
            },
            '&.Mui-disabled': {
              backgroundColor: '#696969',
            },
          }} onClick={() => {
            let modifiedFeedback = "** USER WROTE FEEDBACK, didn't cancel (either accident or decided to keep on paywall) **\n"+feedback
            feedbackIncite(modifiedFeedback)
            setShowSubCancelModal(false)
          }}>
            <Box className="base-text i_understand_text" sx={{
              display: 'flex',
              fontSize: '15px',
              fontWeight: 700, alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              color: '#F2F2F2',
            }}>
              {isTrialing ? 'Continue Trial' : 'Continue Using'}
            </Box>
          </Button>
        </Box>
        
        <Box 
          className="base-text i_understand_text"
          sx={{
            marginTop: '18px',
            opacity: canceling ? 0.55 : 1,
            pointerEvents: canceling ? 'none' : 'auto',
          }}
          onClick={async () => {
            if (canceling) return

            setCanceling(true)
            let modifiedFeedback = "** USER CANCELLING **\n"+feedback
            const result = await handleCancel()
            if (result?.error) {
              setCanceling(false)
              return
            }

            await feedbackIncite(modifiedFeedback, "subscription cancel")

            if (result?.access_ended_immediately) {
              window.location.reload()
              return
            }

            getStripeSubscription()
            setCanceling(false)
            setShowSubCancelModal(false)
          }}
        >
        <Link sx={{
          fontSize: '14px',
          fontWeight: 600,
          color: '#7F7F83', textDecoration: 'none', '&:hover': {cursor: 'pointer', color: '#5F6067'},
        }}>
        {canceling ? 'Canceling...' : isTrialing ? 'Cancel Trial' : 'Cancel Subscription'}
        </Link>
        </Box>

      </div>
    </div>
  )
}

const SubscriptionCancellationCoupon = ({ setShowSubCancelModal, setShowSubCancelOfferModal }) => {
  const [opacity, setOpacity] = useState(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setOpacity(1.0)
  }, [])

  return (
    <div className="modal modal-paywall" style={{
      opacity: opacity,
      transition: 'opacity 1.0s',
      }}>
      <div className="paywall-modal-content" style={{width: '500px', maxWidth: '100%'}}>
        <Box sx={{position: 'absolute', top: '20px', left: '20px', '&:hover': {cursor: 'pointer'}}} onClick={() => setShowSubCancelOfferModal(false)}>
          <CloseIcon sx={{ color: '#444', fontSize: '24px' }} />
        </Box>

        <Box className="base-text" sx={{margin: '36px auto 0px auto', width: '90%', color: '#7F7F83', textAlign: 'center', fontWeight: '500', fontSize: '14px', lineHeight: '150%',}}>
          <Box sx={{color: '#262626', fontWeight: 'bold', fontSize: '16px'}}>
            Continue your membership and get 50% off!
          </Box>
          <br/>
          Keep unlimited access and get 50% off your next
          <br/>
          3 months of membership renewal.
          <br/><br/>
        </Box>

        <Box sx={{width: '260px', margin: '0px auto', maxWidth: '86%', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <Button variant="contained" className="i_understand_button" sx={{
            marginTop: '20px',
            textTransform: 'none',
            borderRadius: '24px',
            boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.05)',
            width: '320px',
            maxWidth: '100%',
            textAlign: 'center',
            '&.Mui-disabled': {
              backgroundColor: '#696969',
            },
          }} 
          onClick={async () => {
            setLoading(true)
            let modifiedFeedback = "** Subscription Saved with 50% Coupon! **\n"
            feedbackIncite(modifiedFeedback, "subscription saved")
            const result = await addSubscriptionCoupon();
            if (result !== "ERROR") {
              setShowSubCancelOfferModal("accepted");
            }
            setLoading(false)
          }}>
            <Box className="base-text i_understand_text" sx={{
              display: 'flex',
              fontSize: '14px',
              fontWeight: 500, alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              marginTop: '1px',
              color: '#F2F2F2',
            }}>
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Keep Unlimited Access"
              )}
            </Box>
          </Button>
        </Box>
        
        <Box className="base-text"  sx={{marginTop: '32px'}} onClick={() => {
          setShowSubCancelOfferModal("declined")
          setShowSubCancelModal(true)
        }}>
        <Link className="base-text" sx={{color: '#7F7F83', textDecoration: 'none', '&:hover': {cursor: 'pointer'} }}>Cancel unlimited</Link>
        </Box>

      </div>
    </div>
  )
}

const SubscriptionOfferCoupon = ({ setShowSubOfferModal }) => {
  const [opacity, setOpacity] = useState(0)
  const [loading] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    setOpacity(1.0)
  }, [])

  return (
    <div className="modal modal-paywall" style={{
      opacity: opacity,
      transition: 'opacity 1.0s',
      }}>
      <div className="paywall-modal-content" style={{width: '500px', maxWidth: '88%'}}>

        <Box className="base-text" sx={{margin: '16px auto 0px auto', width: '90%', color: '#7F7F83', textAlign: 'center', fontWeight: '500', fontSize: '14px', lineHeight: '150%',}}>
          <Box sx={{color: '#262626', fontWeight: 'bold', fontSize: '16px'}}>
            Begin membership and get 50% off!
          </Box>
          <br/>
          Start unlimited access and get 50% off your
          <br/>next 3 months of Incite AI.<br/>
        </Box>

        <Box sx={{width: '260px', margin: '10px auto 0px auto', maxWidth: '86%', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <Button variant="contained" className="i_understand_button" sx={{
            marginTop: '20px',
            textTransform: 'none',
            borderRadius: '24px',
            boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.05)',
            width: '320px',
            maxWidth: '100%',
            textAlign: 'center',
            '&.Mui-disabled': {
              backgroundColor: '#696969',
            },
          }} 
          onClick={async () => {
            navigate('/plan-selection?offer=monthly-market-pro')
          }}>
            <Box className="base-text i_understand_text" sx={{
              display: 'flex',
              fontSize: '14px',
              fontWeight: 500, alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              marginTop: '1px',
              color: '#F2F2F2',
            }}>
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Claim Offer"
              )}
            </Box>
          </Button>
        </Box>
        
        <Box className="base-text" sx={{marginTop: '32px'}} onClick={() => {
          setShowSubOfferModal("declined")
        }}>
        <Link className="base-text" sx={{color: '#7F7F83', textDecoration: 'none', '&:hover': {cursor: 'pointer'} }}>
          no thanks
        </Link>
        </Box>

      </div>
    </div>
  )
}

export { SubscriptionCancellationModal, SubscriptionCancellationCoupon, SubscriptionOfferCoupon }
